import { useEffect, useRef, useState } from "react";
import HeaderUI from "./_Header.presenter";
import { useRouter } from "src/hooks/useRouter";
import { useLogout } from "src/hooks/api/auth/useLogout";
import { navStepAtom, productKeyAtom } from "src/atoms";
import { useRecoilState } from "recoil";
import {
  getProductFromSessionStorage,
  getUserInfoFromLocalStorage,
  setProductToSessionStorage,
} from "src/utils/storage/auth";
import { ProductKey } from "src/config/config";
import checkProductAvailable from "src/utils/product/checkProductAvailable";
import { useCheckIsRenew } from "src/hooks/validation/useCheckIsRenew";
import { useNoticeOne } from "src/hooks/api/notice/useNoticeOne";
import { getCookie, setCookie } from "src/utils/cookie";
import { getLanguage } from "src/utils/localization";
import {
  notifyError,
  notifySuccess,
  notifyWarning,
} from "src/components/Common/Toast";
interface IHeaderContainerProps {
  headerRef: React.RefObject<HTMLDivElement>;
}
const HeaderContainer = ({ headerRef }: IHeaderContainerProps) => {
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [toggleContactOn, setToggleContactOn] = useState<boolean>(false);
  const [toggleAlarmOn, setToggleAlarmOn] = useState<boolean>(false);
  const [toggleUserMenuOn, setToggleUserMenuOn] = useState<boolean>(false);
  const [noticeText, setNoticeText] = useState<string>();
  const [path, setPath] = useState<string>();
  const [product, setProduct] = useState<ProductKey>(
    getProductFromSessionStorage()
  );
  const contactMenuRef = useRef<HTMLDivElement | null>(null);
  const userMenuRef = useRef<HTMLDivElement | null>(null);
  const route = useRouter();
  const { mutateLogout } = useLogout();

  const closeNoticeToday = async () => {
    const timestamp = new Date().getTime();
    const expire = timestamp + 1000 * 60 * 60 * 24;
    const expireDate = new Date(expire);
    setCookie({
      name: "closeTodayNotice",
      value: "YES",
      options: { path: "/", expires: expireDate },
    });
    setNoticeText(undefined);
  };

  const { notice: cloudNoticeInfoOne } = useNoticeOne({});
  const { isRenew } = useCheckIsRenew({});
  useEffect(() => {
    async function init() {
      const closeTodayNotice = getCookie({ name: "closeTodayNotice" });
      // 쿠키 있는지 여부 확인
      if (closeTodayNotice === "YES") {
        setNoticeText(undefined);
      } else if (cloudNoticeInfoOne) {
        // console.log("cloudNoticeInfoOne", cloudNoticeInfoOne);
        // console.log("getLanguage", getLanguage());
        if (getLanguage() === "ko") {
          setNoticeText(cloudNoticeInfoOne[0]?.noticeKo);
        } else if (getLanguage() === "en") {
          setNoticeText(cloudNoticeInfoOne[0]?.noticeEn);
        }
      }
      const querystring = window.location.search.substr(1).split("?");
      const params = new URLSearchParams(querystring[0]);
      // let isRenew = false;
      let newProduct: ProductKey = "WRAPSODY";
      // if (querystring !== '') {
      //   params = new URLSearchParams(querystring[0])
      // }
      // if (params?.has("type") && params?.get("type") === "renew") {
      //   isRenew = true;
      // }
      // let noticeText = "";
      if (getUserInfoFromLocalStorage()) {
        if (
          params.has("product") &&
          (params.get("product") === "WRAPSODY" ||
            params.get("product") === "WRAPSODY_ECO")
        ) {
          newProduct = params.get("product") as ProductKey;
          setProductToSessionStorage(newProduct);

          setPath("console");
          setProduct(newProduct);
        } else if (getProductFromSessionStorage()) {
          setProduct(getProductFromSessionStorage());
        } else if (!getProductFromSessionStorage()) {
          const wrapsodyActive = await checkProductAvailable({
            product: "WRAPSODY", // WRAPSODY
          });
          const ecoActive = await checkProductAvailable({
            product: "WRAPSODY_ECO", // WRAPSODY_ECO
          });
          // console.log("wrapsodyActive ", wrapsodyActive);
          // console.log("ecoActive ", ecoActive);

          // newProduct =
          //   !wrapsodyActive && ecoActive ? "WRAPSODY_ECO" : "WRAPSODY";

          // setProductToSessionStorage(newProduct);

          // setPath("console");
          // setProduct(newProduct);

          // if (wrapsodyActive || ecoActive) {
          //   route.goConsole();
          // } else {
          //   route.goSiteType();
          // }
        }
      }
    }
    init();
  }, [cloudNoticeInfoOne]);
  // useEffect(() => {
  //   setPath(window.location.pathname.split("/").reverse()[0]);
  // }, [route]);
  useEffect(() => {
    const handleOutsideClose = (e: { target: any }) => {
      if (toggleContactOn && !contactMenuRef.current?.contains(e.target)) {
        setToggleContactOn(false);
      }
      if (toggleUserMenuOn && !userMenuRef.current?.contains(e.target)) {
        setToggleUserMenuOn(false);
      }
    };
    document.addEventListener("click", handleOutsideClose);
    return () => document.removeEventListener("click", handleOutsideClose);
  }, [toggleContactOn, toggleUserMenuOn]);

  // document.addEventListener('mousedown', handleClickOutside)

  // componentWillUnmount = () => {
  //   document.removeEventListener('mousedown', this.handleClickOutside)
  // }

  // setWrapperRef(node) {
  //   this.wrapperRef = node
  // }

  // handleClickOutside(event) {
  //   if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
  //     this.setState({
  //       ...this.state,
  //       toggleContactOn: false,
  //       toggleAlarmOn: false,
  //       toggleUserMenuOn: false
  //     })
  //   }
  // }

  const closeNotice = () => {
    setNoticeText("");
  };

  // const CheckProductAvailable = (product: string) => {
  //   // const checkCashStatus = await getCashUserStatus({
  //   //   product: [product],
  //   // });
  //   const { isAvailable, mutateGetCashUserStatus } = useCheckProductAvailable({
  //     product,
  //   });
  //   mutateGetCashUserStatus({ product: [product] });
  //   return isAvailable;
  // };

  const toggleContact = () => {
    setToggleContactOn((prev) => !prev);
    setToggleAlarmOn(false);
    setToggleUserMenuOn(false);
  };

  const toggleAlarm = () => {
    setToggleContactOn(false);
    setToggleAlarmOn((prev) => !prev);
    setToggleUserMenuOn(false);
  };

  const toggleUserMenu = () => {
    setToggleContactOn(false);
    setToggleAlarmOn(false);
    setToggleUserMenuOn((prev) => !prev);
  };
  // const handleChangeForDropdown = (name:string, value:string) => {

  //   state[name] = value
  //   setProductToSessionStorage(value)
  //   this.setState(state)
  //   window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
  //   route.goConsole();
  // }

  return (
    <>
      {/* <div>
        <button onClick={() => notifySuccess("test")}>success</button>
        <button onClick={() => notifyWarning("test")}>warning</button>
        <button onClick={() => notifyError("test")}>error</button>
      </div> */}
      <HeaderUI
        logout={mutateLogout}
        path={path}
        goConsole={route.goConsole}
        goBill={route.goBill}
        toggleContact={toggleContact}
        toggleContactOn={toggleContactOn}
        toggleUserMenu={toggleUserMenu}
        toggleUserMenuOn={toggleUserMenuOn}
        // setWrapperRef={setWrapperRef}
        noticeText={cloudNoticeInfoOne && noticeText}
        closeNoticeToday={closeNoticeToday}
        closeNotice={closeNotice}
        navStep={navStep}
        product={product}
        // handleChangeForDropdown={handleChangeForDropdown}
        isRenew={isRenew}
        headerRef={headerRef}
        contactMenuRef={contactMenuRef}
        userMenuRef={userMenuRef}
      />
      {/* {cloudNoticeInfoOne && cloudNoticeInfoOne[0].noticeKo} */}
    </>
  );
};

export default HeaderContainer;
